import { render, staticRenderFns } from "./SelectProvider.vue?vue&type=template&id=5ede09a0&"
import script from "./SelectProvider.vue?vue&type=script&lang=ts&"
export * from "./SelectProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports